import { render } from "./CreateTradeWSModal.vue?vue&type=template&id=eb7105ee&ts=true"
import script from "./CreateTradeWSModal.vue?vue&type=script&lang=ts"
export * from "./CreateTradeWSModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__